import { readState } from "@/__main__/app-state.mjs";
import { IS_APP } from "@/__main__/constants.mjs";
import type { ActiveRoute } from "@/__main__/router.mjs";
import router, { EVENT_CHANGE_ROUTE } from "@/__main__/router.mjs";
import {
  setLocalProfileId,
  setVolatileKV,
  writeLocalState,
} from "@/app/actions.mjs";
import { GAME_SHORT_NAMES } from "@/app/constants.mjs";
import { getNavProfile } from "@/app/util.mjs";
import type { AppSettings } from "@/data-models/app-settings.mjs";
import clone from "@/util/clone.mjs";
import { findGameSymbol } from "@/util/game-route.mjs";
import gameShortNameReassign from "@/util/game-short-name-reassign.mjs";

const currentGameListener = (route: ActiveRoute) => {
  const gameSymbol = findGameSymbol();

  const shortName = GAME_SHORT_NAMES[gameSymbol];

  if (gameSymbol) {
    const loggedInAccounts =
      readState.settings.loggedInAccounts[gameShortNameReassign(shortName)];
    const currentProfileId = Object.entries(loggedInAccounts)
      .filter(([_, account]) => account)
      .find(
        ([_, account]: [
          string,
          AppSettings["loggedInAccounts"][keyof AppSettings["loggedInAccounts"]][string],
        ]) =>
          getNavProfile({ gameSymbol, account })?.profileUrl?.toLowerCase() ===
          route.currentPath?.toLowerCase(),
      )?.[0];

    if (
      currentProfileId &&
      currentProfileId !== readState.localState.currentProfileId[shortName]
    ) {
      setLocalProfileId(gameSymbol, currentProfileId);
    }

    //We do  not persist currentGame in web to prevent post hydration issues
    if (IS_APP) {
      const localState = clone(readState.localState);
      const storedGameSymbol = localState?.currentGame;

      if (storedGameSymbol !== gameSymbol) {
        writeLocalState(["currentGame"], gameSymbol);
      }
    } else {
      const currentGameSymbol = readState.volatile.currentGame;
      if (currentGameSymbol !== gameSymbol) {
        setVolatileKV("currentGame", gameSymbol);
      }
    }
  }
};

export function registerCurrentGameListener() {
  router.events.on(EVENT_CHANGE_ROUTE, currentGameListener);
}

export function unregisterCurrentGameListener() {
  router.events.off(EVENT_CHANGE_ROUTE, currentGameListener);
}
